import type {
  ScopedOffer,
  LocalAttachment,
  BundleProduct,
  StandardProduct,
} from '#shared/types/goliath/goliath.types';
import { getGoliathImages, type LocalImage } from '@i22team/rocket';

const extractMediaFromOffer = (
  offer: ListOffer | Offer | BundleProduct | StandardProduct | ScopedOffer,
  images: LocalAttachment[] = []
) => {
  if (!offer?.media) return;
  offer.media.forEach((media) => {
    if (media && media.remote === false && 'mediaId' in media) {
      if (images.find((i) => i.mediaId === media.mediaId)) return;
      images.push(media as LocalAttachment);
    }
  });
};

export const getImagesFromOffer = <O extends ListOffer | Offer | ScopedOffer | undefined>(
  offer: O
): LocalImage[] => {
  if (!offer) return [];
  const baseImages: LocalAttachment[] = [];

  extractMediaFromOffer(offer, baseImages);

  if (
    baseImages.length === 0 &&
    offer.product &&
    'teaserImage' in offer.product &&
    !offer.product.teaserImage?.remote
  ) {
    baseImages.push(offer.product.teaserImage as LocalAttachment);
  }

  const product = offer?.product || {};
  const bundledProducts = 'bundledProducts' in product ? product.bundledProducts || [] : [];

  if (bundledProducts) {
    bundledProducts.forEach((bundledProduct) => {
      if (!bundledProduct) return;
      extractMediaFromOffer(bundledProduct, baseImages);
    });
  }

  return getGoliathImages({ media: baseImages });
};

export const getMainImageFromOffer = <O extends ListOffer | ScopedOffer | Offer>(
  offer: O | undefined,
  index = 0
) => {
  if (!offer) return undefined;
  const offerImages = getImagesFromOffer(offer);
  if (offerImages.length < index + 1) return undefined;
  return offerImages[index];
};
